{
  "nl": {
    "lead": {
      "actions": {
        "add_company": "Organisatie toevoegen",
        "add_lead": "Voeg lead toe",
        "new": "Lead"
      },
      "attributes": {
        "address": "Adres",
        "birth_date": "Geboortedatum",
        "categories": {
          "enduser": "Koper-bewoner",
          "investor": "Investeerder"
        },
        "category": "Leadtype",
        "company_name": "Organisatienaam",
        "company_vat": "btw-nummer",
        "email_address": "E-mail",
        "first_name": "Voornaam",
        "iban": "IBAN",
        "internal_note": "Interne opmerking",
        "language": "Taal",
        "last_name": "Achternaam",
        "phone_landline": "Vast nummer",
        "phone_mobile": "Mobiel nummer",
        "status": "status"
      },
      "labels": {
        "detailed_information": "Voer gedetailleerde informatie in",
        "lead": "Lead"
      },
      "validation": {
        "needFirstName": "Voornaam verplicht",
        "needLastName": "Achternaam verplicht"
      }
    }
  }
}
